import React from 'react';

interface AnimatedLogoProps {
  className?: string;
}

export const AnimatedLogo: React.FC<AnimatedLogoProps> = ({ className }) => (
  <>
    <style>{`
      @property --trace-angle {
        syntax: '<angle>';
        initial-value: 0deg;
        inherits: false;
      }
      @keyframes border-trace {
        to { --trace-angle: 360deg; }
      }
      @keyframes border-fade {
        to { opacity: 0; }
      }
      .logo-box {
        position: relative;
      }
      .logo-box::before {
        content: '';
        position: absolute;
        inset: -2px;
        border-radius: 14px;
        padding: 2px;
        background: conic-gradient(from 0deg, #8B5CF6 var(--trace-angle), transparent var(--trace-angle));
        -webkit-mask:
          linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        animation: border-trace 0.8s ease-out forwards, border-fade 0.3s ease-out 0.9s forwards;
        pointer-events: none;
      }
    `}</style>
    <div className="logo-box rounded-xl p-1.5 bg-gradient-to-b from-white/90 to-white border border-white/60 shadow-[0_2px_8px_rgba(0,0,0,0.12),inset_0_1px_2px_rgba(255,255,255,0.9),inset_0_-1px_3px_rgba(0,0,0,0.06)] backdrop-blur-xl">
      <img src="/logo.png" alt="TallyUp Finance" className={className} />
    </div>
  </>
);
